export const NEWSLETTER_MESSAGES = {
  SUCCESS: "Langganan anda berjaya.", // Your subscription is successful.
  UNSUB_SUCCESS: "Langganan anda berjaya dikemas kini.", // Your subscription has been successfully updated.
  FAILED: "Langganan anda terdapat masalah.", // There is a problem with your subscription.
  INVALID_EMAIL: "Alamat email tidak sah", // Invalid email address
};

export const NEWSLETTER_CONTACT_LIST_ID = "934866939";
